import { render, staticRenderFns } from "./periodic-wizard-invoices.vue?vue&type=template&id=9957b97a&"
import script from "./periodic-wizard-invoices.vue?vue&type=script&lang=js&"
export * from "./periodic-wizard-invoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports